// Mock data for YFT Group website

export const heroData = {
  headline: "Four decades of growth in the\u00A0UAE",
  subline: "YFT Group is a diversified enterprise spanning retail, apparel, real estate, manufacturing, distribution, and beauty services",
  videoPlaceholder: "Video placeholder: Use Google Flow to generate 10s cinematic montage",
  buttons: [
    { text: "Explore our story", link: "#legacy", type: "primary" },
    { text: "Contact us", link: "#contact", type: "secondary" }
  ]
};

export const legacyData = {
  title: "A legacy built on enterprise and growth",
  timeline: [
    {
      year: "1980s",
      description: "Began operations in Dubai through early retail trading and wholesale garment activity, establishing roots in Murshid Bazaar",
      tag: "Retail and apparel"
    },
    {
      year: "1990s",
      description: "Expanded retail and wholesale operations. Strengthened sourcing networks across Asia and the Middle East",
      tag: "Retail and apparel"
    },
    {
      year: "2000s",
      description: "Launched Cash & Carry stores in Dubai. Entered partnerships with international apparel brands",
      tag: "Retail and apparel"
    },
    {
      year: "2009",
      description: "Opened the Jawed Habib hair salon franchise in Dubai",
      tag: "Hair and beauty"
    },
    {
      year: "2012",
      description: "Launched Cottny, an in-house personal care brand",
      tag: "Retail and apparel"
    },
    {
      year: "2014",
      description: "Gained exclusive distribution rights for Jockey in the UAE. Opened multiple Jockey franchise stores across the UAE",
      tag: "Retail and apparel"
    },
    {
      year: "2016",
      description: "Secured exclusive distribution rights for Hanes in the UAE",
      tag: "Retail and apparel"
    },
    {
      year: "2017",
      description: "Secured licensing rights for Hasbro, Rovio, and Moose Toys across MENA",
      tag: "Retail and apparel"
    },
    {
      year: "2018",
      description: "Secured licensing rights for Emoji across MENA. Opened Nigeria office. Secured licensing rights for FIFA World Cup Russia across MENA",
      tag: "Retail and apparel"
    },
    {
      year: "2019",
      description: "Launched Kenya office and gained exclusive distribution rights for Rupa Innerwear in UAE, Nigeria, and Kenya",
      tag: "Retail and apparel"
    },
    {
      year: "2020",
      description: "Secured distribution rights for American Garden and Britannia in Nigeria. Secured licensing rights for Disney and Marvel across MENA. Launched medical supplies division providing face masks and gloves during COVID",
      tag: "Retail and apparel"
    },
    {
      year: "2021",
      description: "Secured licensing rights for Warner Bros, Peanuts, and Pink Panther across GCC",
      tag: "Retail and apparel"
    },
    {
      year: "2025",
      description: "Rebranded Crossover Bollywood as a unisex Bollywood-inspired salon concept in Dubai. Continued diversification into residential and commercial real estate with OAMS Property Management",
      tag: "Hair and beauty"
    },
    {
      year: "2026 onward",
      description: "Expanded into manufacturing, assembly, and mobility-related production for electric vehicles",
      tag: "Manufacturing"
    }
  ]
};

export const businessesData = {
  retail: {
    title: "Retail and Distribution",
    description: "For over three decades, YFT Group has partnered with global fashion and lifestyle brands across the Middle East and Africa",
    highlights: [
      "Exclusive distribution rights for Hanes, Jockey, Disney, Marvel, Rupa, and FIFA-licensed merchandise",
      "In-house labels: Cottny, V-Kids, Naina, Body, Valmont, SP Casuals, Bodice"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/pqftf7s7_WhatsApp%20Image%202025-12-08%20at%2017.48.00.jpeg",
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/6ukn0qhb_WhatsApp%20Image%202025-12-08%20at%2017.49.46.jpeg",
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/qydnlkpm_WhatsApp%20Image%202025-12-08%20at%2017.48.53.jpeg",
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/yijnuyp3_WhatsApp%20Image%202025-12-08%20at%2017.48.22.jpeg",
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/olfkkzrf_WhatsApp%20Image%202025-12-10%20at%2013.19.57.jpeg",
      "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/bjhvfft1_WhatsApp%20Image%202025-12-10%20at%2013.20.10.jpeg"
    ]
  },
  beauty: {
    title: "Hair and beauty",
    description: "YFT Group operates premium salon concepts serving diverse communities across the UAE",
    highlights: [
      "Jawed Habib hair salon franchise operations",
      "Crossover Bollywood: Dubai's only Bollywood-inspired unisex salon concept"
    ],
    websiteUrl: "https://crossoverbollywood.ae",
    websiteText: "Visit Crossover Bollywood",
    images: [
      {
        url: "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/rse0vtt5_crossover.avif",
        position: "center center"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/b4s0nbck_WhatsApp%20Image%202025-11-16%20at%2017.20.22.jpeg",
        position: "center center"
      }
    ]
  },
  additionalInvestments: {
    title: "Additional investments",
    description: "YFT Group has additional holdings across residential and commercial real estate, manufacturing, and food & beverage",
    highlights: [
      "Residential and commercial property investments across Dubai",
      "Food and beverage distribution partnerships",
      "Emerging interests in sustainable mobility and electric vehicle assembly"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/veb56hli_Dubai%20Real%20Estate%20Developer%202025.webp",
      "https://customer-assets.emergentagent.com/job_dubai-yft/artifacts/nwnp2xfy_image.png",
      "https://customer-assets.emergentagent.com/job_dubai-yft/artifacts/ql6knbxd_image.png"
    ]
  }
};

export const visionData = {
  title: "Operating principles",
  values: [
    {
      title: "Strategic focus",
      description: "We make informed decisions based on market intelligence, operational discipline, and long-term value creation"
    },
    {
      title: "Partnership integrity",
      description: "We build enduring relationships with suppliers, distributors, and stakeholders through transparency and consistent execution"
    },
    {
      title: "Operational excellence",
      description: "We pursue continuous improvement across all business units, from sourcing and distribution to property management and manufacturing"
    }
  ]
};

export const leadershipData = {
  title: "Leadership",
  subtitle: "Experienced management across diverse sectors",
  leaders: [
    {
      name: "Shyam Das Pagarani",
      title: "Founder",
      description: "Established YFT Group in 1987, building operations from wholesale garments to a diversified regional enterprise",
      image: "https://customer-assets.emergentagent.com/job_luxury-dubai-1/artifacts/5ld6y5ud_barepapa.jpeg",
      imagePosition: "85% center",
      linkedin: ""
    },
    {
      name: "Anil Pagarani",
      title: "Managing Director",
      description: "Leads strategic operations across retail distribution, brand partnerships, real estate development, and regional expansion initiatives",
      image: "https://customer-assets.emergentagent.com/job_dubai-yft/artifacts/wiork5ps_WhatsApp%20Image%202026-03-05%20at%2009.00.29.jpeg",
      imagePosition: "center center",
      linkedin: "https://www.linkedin.com/in/anil-pagarani-13848466/"
    }
  ]
};

export const galleryData = {
  title: "Our story in pictures",
  images: [
    {
      url: "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/jlx76ku5_yft_1.jpeg",
      caption: "Retail: Original storefront at Mohit Bazaar",
      alt: "Yellow Flower Trading original store"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/y18laho1_WhatsApp%20Image%202025-11-27%20at%2012.56.20.jpeg",
      caption: "Recognition: Crossover Bollywood Hair Salon award",
      alt: "Crossover Bollywood award ceremony"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/wq54sb2p_WhatsApp%20Image%202025-11-27%20at%2012.54.27.jpeg",
      caption: "Expansion: Our retail locations and advertising",
      alt: "YFT Group retail locations and marketing"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/72f8nt2p_WhatsApp%20Image%202025-10-23%20at%2022.15.50.jpeg",
      caption: "Family: The Pagarani family together",
      alt: "YFT Group Pagarani family photo"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/dovdhrbg_WhatsApp%20Image%202025-10-24%20at%2008.01.33.jpeg",
      caption: "Partnership: Launch day with OSM Seiki founder",
      alt: "YFT Group and Omega Seiki Mobility partnership launch"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_a307793e-ccfd-435d-8dc0-0e1809880abf/artifacts/ze8ct44y_Screenshot%202025-11-10%20at%2011.35.29%E2%80%AFAM.png",
      caption: "Manufacturing: EV assembly partnership",
      alt: "Manufacturing facility and EV production"
    }
  ],
  linkedinUrl: "https://www.linkedin.com/company/yellow-flower-trading/about/"
};

export const contactData = {
  title: "Connect with us",
  subtitle: "We welcome partnerships, inquiries, and opportunities to collaborate",
  email: "info@yellowft.com",
  phone: "+9714 2733257",
  address: "Office # 237, Dubai Textile City, Al Warsan, Behind Dragon Mart 2, Dubai International City, - Dubai – United Arab Emirates.",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.2974877846737!2d55.4091089!3d25.1677656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f64e670c12345%3A0x123456789abcdef0!2sDubai%20Textile%20City!5e0!3m2!1sen!2sae!4v1234567890",
  linkedin: "https://www.linkedin.com/company/yellow-flower-trading/about/",
  careersEmail: "hr@yellowft.com"
};

export const navigationData = {
  logo: {
    image: "https://customer-assets.emergentagent.com/job_dubai-yft/artifacts/xucx8uum_YFT%20Group%20Business%20Card.png",
    alt: "YFT Group Logo",
    text: "YFT Group"
  },
  links: [
    { text: "Legacy", href: "#legacy" },
    { text: "Businesses", href: "#businesses" },
    { text: "Operating principles", href: "#vision" },
    { text: "Leadership", href: "#leadership" },
    { text: "Contact", href: "#contact" }
  ]
};

export const footerData = {
  tagline: "Four decades of growth across the Middle East and Africa",
  links: [
    { text: "About Us", href: "#legacy" },
    { text: "Businesses", href: "#businesses" },
    { text: "Leadership", href: "#leadership" },
    { text: "Contact", href: "#contact" },
    { text: "Careers", href: "mailto:careers@yftgroup.ae" }
  ],
  social: [
    { platform: "LinkedIn", url: "https://www.linkedin.com/company/yellow-flower-trading/about/" }
  ],
  copyright: `© ${new Date().getFullYear()} YFT Group. All rights reserved.`,
  credits: "Built with care by the YFT team"
};